import type { StrategyRecord } from '../types/account';

export const getPublishStrategyId = (strategy: StrategyRecord): string => (
  strategy.strategyId || strategy.id || strategy.aiStrategyId
);

export const getStrategyHref = (strategy: StrategyRecord): string => (
  strategy.conversationId
    ? `/ai-agent/${strategy.conversationId}`
    : `/ai-agent?aiStrategyId=${strategy.aiStrategyId}`
);

export const resolveStrategyRevisionId = (strategy: StrategyRecord): string => (
  strategy.latestRevisionId
  || strategy.defaultRevisionId
  || strategy.revisionId
  || strategy.latestBacktest?.revisionId
  || ''
);

export const getBacktestHref = (strategy: StrategyRecord): string => {
  const revisionId = resolveStrategyRevisionId(strategy);
  if (!strategy.aiStrategyId || !revisionId) return getStrategyHref(strategy);
  return `/backtest/${encodeURIComponent(strategy.aiStrategyId)}/${encodeURIComponent(revisionId)}`;
};

export const getDeployHrefIfReady = (strategy: StrategyRecord): string | null => {
  const revisionId = resolveStrategyRevisionId(strategy);
  const strategyId = getPublishStrategyId(strategy);
  if (!strategy.aiStrategyId || !revisionId || !strategyId) return null;

  const params = new URLSearchParams({
    strategyId,
    aiStrategyId: strategy.aiStrategyId,
    aiStrategyRevisionId: revisionId,
    isPublic: 'false',
  });
  return `/deploy?${params.toString()}`;
};

export const getDeployHref = (strategy: StrategyRecord): string => {
  const deployHref = getDeployHrefIfReady(strategy);
  return deployHref || getStrategyHref(strategy);
};

export const getMarketplaceHref = (strategy: StrategyRecord): string => {
  const listingId = strategy.marketplace?.marketplaceListingId;
  if (listingId) return `/marketplace/strategy/${encodeURIComponent(listingId)}`;
  return getStrategyHref(strategy);
};
